import { instance } from '@cognitivecredit/ui-utils'
import collapsedTrace from '@/utils/collapsedTrace'
import serializeComparables from '@/utils/comparables/serializeComparables'

export default async (compsType, options) => {
  // When the user arrives via the Biggest Movers widget (mover_identifier is
  // present in the route), we load the sheet without applying persisted state.
  // Filter or sort changes the user makes during that session should not
  // overwrite those persisted settings either.
  // Dynamic import avoids a circular dependency: persistComps ← actions ← stores ← hooks ← router ← persistComps
  const { default: router } = await import('@/router')
  if (router.currentRoute.value.query.mover_identifier) {
    return
  }

  collapsedTrace('persistComps', compsType, options)
  const persistableProperties = serializeComparables(compsType, options)
  if (persistableProperties === null) {
    return
  }
  const req = await instance({ prefix: 'user-management' })
  req({
    url: `user/comps-settings`,
    method: 'POST',
    data: persistableProperties,
  })
}
